import { SEARCH_MAX_CAP_FAILURE, SEARCH_MAX_CAP_REQUEST, SEARCH_MAX_CAP_RESET, SEARCH_MAX_CAP_SUCCESS } from "redux/actions/action-type";

const initialState = {
    isSearchLoading: false,
    isSearchSuccess: false,
    isSearchFail: false,
    searchMaxCapResponse: {},
};

export const searchMaxCapReducer = (state = initialState, { type, searchMaxCapResponse }) => {
    switch (type) {
        case SEARCH_MAX_CAP_REQUEST:
            return {
                ...state,
                isSearchLoading: true,
                isSearchSuccess: false,
                isSearchFail: false,
            };
        case SEARCH_MAX_CAP_SUCCESS:
            return {
                ...state,
                searchMaxCapResponse: searchMaxCapResponse,
                isSearchLoading: false,
                isSearchSuccess: true,
                isSearchFail: false,
            };
        case SEARCH_MAX_CAP_FAILURE:
            return {
                ...state,
                searchMaxCapResponse: searchMaxCapResponse,
                isSearchLoading: false,
                isSearchSuccess: false,
                isSearchFail: true,
            };
        case SEARCH_MAX_CAP_RESET:
            return { ...initialState };
        default:
            return { ...state };
    }
};
